import React from "react";

const ItemPerPage = ({ setItemNoPerPage, itemNoPerPage }) => {
  return (
    <div className="flex">
      <label>Page per page: </label>
      <select
        onChange={(e) => setItemNoPerPage(Number(e.target.value))}
        value={itemNoPerPage}
      >
        <option value="2">2</option>
        <option value="10">10</option>
        <option value="8">8</option>
        <option value="5">5</option>
      </select>
    </div>
  );
};

export default ItemPerPage;
